import Api from '@/api/UploadApi'
import toast from '@/mixins/toast'

export default {
 
    upload (payload, notificationId, requestTypeId, category, description) {
        let _url = '/upload/'+ notificationId +'/'+ requestTypeId+'/'+ category +'/'+ description
        console.log(_url)
        return Api().post(_url, payload).then( (response) => {
              return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    nsl2kml (payload) {
        let _url = '/upload/nsl2kml'
        console.log(_url)
        return Api().post(_url, payload).then( (response) => {
              return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    pax2csv (payload) {
        let _url = '/upload/pax2csv'
        console.log(_url)
        return Api().post(_url, payload).then( (response) => {
              return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    gps (payload) {
        let _url = '/upload/gps'
        console.log(_url)
        return Api().post(_url, payload).then( (response) => {
              return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    remove (payload) {
        return Api().get('/upload/remove/'+ payload.notification_id +'/'+ payload.id).then( (response) => {
              return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    }
}    


// WEBPACK FOOTER //
// ./src/api/UploadService.js